module.exports = __webpack_public_path__ + "static/media/shuffle.32a7fd2d.svg";